export default {
  "津堂城山古墳": {
    icon: "keyhole-wh_min",
    length: '210m'
  },
  "庭鳥塚古墳": {
    icon: "keyhole_min",
    length: '60m'
  },
  "乳岡古墳": {
    icon: "keyhole_min",
    length: '155m'
  },
  "仲姫命陵古墳": {
    icon: "keyhole-wh_min",
    length: '290m'
  },
  "五手治古墳": {
    icon: "round-dis_min",
    length: '33m'
  },
  "高塚山古墳": {
    icon: "round-dis_min",
    length: '50m'
  },
  "岡古墳": {
    icon: "square-dis_min",
    length: '33m'
  },
  "アリ山古墳": {
    icon: "square-dis_min",
    length: '45m'
  },
  "西墓山古墳": {
    icon: "square-dis_min",
    length: '20m'
  },
  "狼塚古墳": {
    icon: "round-dis_min",
    length: '28m'
  },
  "野中宮山古墳": {
    icon: "keyhole_min",
    length: '154m'
  },
  "大塚山古墳": {
    icon: "keyhole-dis_min",
    length: '168m'
  },
  "誉田丸山古墳": {
    icon: "round-wh_min",
    length: '50m'
  },
  "応神天皇陵古墳": {
    icon: "keyhole-wh_min",
    length: '425m'
  },
  "墓山古墳": {
    icon: "keyhole-wh_min",
    length: '225m'
  },
  "仁徳天皇陵古墳": {
    icon: "keyhole-wh_min",
    length: '486m'
  },
  "中山塚古墳": {
    icon: "square-wh_min",
    length: '50m'
  },
  "栗塚古墳": {
    icon: "square-wh_min",
    length: '43m'
  },
  "善右ヱ門山古墳": {
    icon: "square-wh_min",
    length: '28m'
  },
  "御廟山古墳": {
    icon: "keyhole-wh_min",
    length: '203m'
  },
  "旗塚古墳": {
    icon: "scallop-wh_min",
    length: '58m'
  },
  "収塚古墳": {
    icon: "scallop-wh_min",
    length: '59m'
  },
  "寺山南山古墳": {
    icon: "square-wh_min",
    length: '45m'
  },
  "七観山古墳": {
    icon: "round-dis_min",
    length: '56m'
  },
  "いたすけ古墳": {
    icon: "keyhole-wh_min",
    length: '146m'
  },
  "塚廻古墳": {
    icon: "round-wh_min",
    length: '35m'
  },
  "履中天皇陵古墳": {
    icon: "keyhole-wh_min",
    length: '365m'
  },
  "反正天皇陵古墳": {
    icon: "keyhole-wh_min",
    length: '148m'
  },
  "大鳥塚古墳": {
    icon: "keyhole-wh_min",
    length: '110m'
  },
  "はざみ山古墳": {
    icon: "keyhole-wh_min",
    length: '103m'
  },
  "浄元寺山古墳": {
    icon: "square-wh_min",
    length: '67m'
  },
  "長持山古墳": {
    icon: "round-dis_min",
    length: '40m'
  },
  "藤の森古墳": {
    icon: "round-dis_min",
    length: '22m'
  },
  "島泉丸山古墳": {
    icon: "round_min",
    length: '75m'
  },
  "鞍塚古墳": {
    icon: "scallop-dis_min",
    length: '51m'
  },
  "黒姫山古墳": {
    icon: "keyhole_min",
    length: '114m'
  },
  "鎮守山塚古墳": {
    icon: "round_min",
    length: '34m'
  },
  "文珠塚古墳": {
    icon: "keyhole_min",
    length: '59m'
  },
  "松川塚古墳": {
    icon: "square_min",
    length: '25m'
  },
  "西清水古墳": {
    icon: "square-dis_min",
    length: '30m'
  },
  "野中古墳": {
    icon: "square-wh_min",
    length: '37m'
  },
  "仲哀天皇陵古墳": {
    icon: "keyhole-wh_min",
    length: '245m'
  },
  "峯ヶ塚古墳": {
    icon: "keyhole-wh_min",
    length: '96m'
  },
  "西馬塚古墳": {
    icon: "square-wh_min",
    length: '45m'
  },
  "城ノ山古墳": {
    icon: "keyhole-dis_min",
    length: '77m'
  },
  "カトンボ山古墳": {
    icon: "round-dis_min",
    length: '50m'
  },
  "湯の山古墳": {
    icon: "round-dis_min",
    length: '20m'
  },
  "長塚古墳": {
    icon: "keyhole-wh_min",
    length: '106m'
  },
  "御廟表塚古墳": {
    icon: "keyhole_min",
    length: '85m'
  },
  "ニサンザイ古墳": {
    icon: "keyhole-wh_min",
    length: '300m'
  },
  "允恭天皇陵古墳": {
    icon: "keyhole-wh_min",
    length: '230m'
  },
  "白鳥陵古墳": {
    icon: "keyhole-wh_min",
    length: '200m'
  },
  "唐櫃山古墳": {
    icon: "keyhole_min",
    length: '59m'
  },
  "赤子塚古墳": {
    icon: "round-dis_min",
    length: '34m'
  },
  "土師の里８号墳": {
    icon: "square-dis_min",
    length: '12m'
  },
  "葛井寺１号墳": {
    icon: "round-dis_min",
    length: '10m'
  },
  "蕃上山古墳": {
    icon: "keyhole-dis_min",
    length: '53m'
  },
  "軽里４号墳": {
    icon: "keyhole-dis_min",
    length: '18m'
  },
  "矢倉古墳": {
    icon: "round-dis_min",
    length: '28m'
  },
  "潮音寺北古墳": {
    icon: "round-dis_min",
    length: '22m'
  },
  "水塚古墳": {
    icon: "keyhole-dis_min",
    length: '47m'
  },
  "春日山田皇后陵": {
    icon: "keyhole_min",
    length: '85m'
  },
  "仁賢天皇陵古墳": {
    icon: "keyhole_min",
    length: '122m'
  },
  "清寧天皇陵古墳": {
    icon: "keyhole_min",
    length: '115m'
  },
  "小白髪山古墳": {
    icon: "keyhole_min",
    length: '46m'
  },
  "城不動坂古墳": {
    icon: "keyhole-dis_min",
    length: '36m'
  },
  "今井塚古墳": {
    icon: "round-dis_min",
    length: '30m'
  },
  "下田池古墳": {
    icon: "round-dis_min",
    length: '25m'
  },
  "安閑天皇陵古墳": {
    icon: "keyhole_min",
    length: '122m'
  },
  "青山２号墳": {
    icon: "keyhole-dis_min",
    length: '33m'
  },
  "青山３号墳": {
    icon: "keyhole-dis_min",
    length: '8m'
  },
  "青山４号墳": {
    icon: "square-dis_min",
    length: '20m'
  },
  "青山５号墳": {
    icon: "keyhole-dis_min",
    length: '7m'
  },
  "青山６号墳": {
    icon: "keyhole-dis_min",
    length: '14m'
  },
  "小具足塚古墳": {
    icon: "square-dis_min",
    length: '20m'
  },
  "向墓山古墳": {
    icon: "square-wh_min",
    length: '68m'
  },
  "軽里2号墳": {
    icon: "round-dis_min",
    length: '25m'
  },
  "白鳥1号墳": {
    icon: "round-dis_min",
    length: '20m'
  },
  "白鳥2号墳": {
    icon: "round-dis_min",
    length: '20m'
  },
  "翠鳥園1号墳": {
    icon: "square-dis_min",
    length: '12m'
  },
  "茶山1号墳": {
    icon: "square-dis_min",
    length: '10m'
  },
  "長山古墳": {
    icon: "keyhole-dis_min",
    length: '110m'
  },
  "定の山古墳": {
    icon: "scallop_min",
    length: '69m'
  },
  "平井塚古墳": {
    icon: "keyhole-dis_min",
    length: '58m'
  },
  "鳶塚古墳": {
    icon: "round-dis_min",
    length: '21m'
  },
  "赤山古墳": {
    icon: "round-dis_min",
    length: '20m'
  },
  "古室山古墳": {
    icon: "keyhole-wh_min",
    length: '150m'
  },
}



// WEBPACK FOOTER //
// ./map/js/ih/data/mozu-furu-artifact_kofun_data.js